import React from "react";

export function DemoImage1() {
  return (
    <svg
      width="56"
      height="58"
      viewBox="0 0 56 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3333 15.0336H18.6667C19.097 15.0336 19.5 15.4156 19.5 15.9558V55.7779C19.5 56.3181 19.097 56.7001 18.6667 56.7001H13.3333C12.903 56.7001 12.5 56.3181 12.5 55.7779V15.9558C12.5 15.4156 12.903 15.0336 13.3333 15.0336Z"
        fill="#5AE0A0"
        stroke="black"
      />
      <path
        d="M25.3333 29.2557H30.6667C31.097 29.2557 31.5 29.6377 31.5 30.178V55.7779C31.5 56.3181 31.097 56.7001 30.6667 56.7001H25.3333C24.903 56.7001 24.5 56.3181 24.5 55.7779V30.178C24.5 29.6377 24.903 29.2557 25.3333 29.2557Z"
        fill="#D1FDE8"
        stroke="black"
      />
      <path
        d="M37.3333 15.0336H42.6667C43.097 15.0336 43.5 15.4156 43.5 15.9558V55.7779C43.5 56.3181 43.097 56.7001 42.6667 56.7001H37.3333C36.903 56.7001 36.5 56.3181 36.5 55.7779V15.9558C36.5 15.4156 36.903 15.0336 37.3333 15.0336Z"
        fill="#5AE0A0"
        stroke="black"
      />
      <path
        d="M49.3333 29.2557H54.6667C55.097 29.2557 55.5 29.6377 55.5 30.178V55.7779C55.5 56.3181 55.097 56.7001 54.6667 56.7001H49.3333C48.903 56.7001 48.5 56.3181 48.5 55.7779V30.178C48.5 29.6377 48.903 29.2557 49.3333 29.2557Z"
        fill="#D1FDE8"
        stroke="black"
      />
      <path
        d="M1.33333 0.811401H6.66667C7.097 0.811401 7.5 1.19341 7.5 1.73362V55.7779C7.5 56.3181 7.097 56.7001 6.66667 56.7001H1.33333C0.903002 56.7001 0.5 56.3181 0.5 55.7779V1.73362C0.5 1.19341 0.903002 0.811401 1.33333 0.811401Z"
        fill="#5AE0A0"
        stroke="black"
      />
    </svg>
  );
}
export function DemoImage2() {
  return (
    <svg
      width="74"
      height="127"
      viewBox="0 0 74 127"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 20.2887C8.85652 20.2887 10.637 19.544 11.9497 18.2183C13.2625 16.8926 14 15.0945 14 13.2197C14 15.0945 14.7375 16.8926 16.0503 18.2183C17.363 19.544 19.1435 20.2887 21 20.2887"
        stroke="#5AE0A0"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M7 20.2887C8.85652 20.2887 10.637 21.0335 11.9497 22.3592C13.2625 23.6849 14 25.4829 14 27.3577C14 25.4829 14.7375 23.6849 16.0503 22.3592C17.363 21.0335 19.1435 20.2887 21 20.2887"
        stroke="#5AE0A0"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M53 20.2887C54.8565 20.2887 56.637 19.544 57.9497 18.2183C59.2625 16.8926 60 15.0945 60 13.2197C60 15.0945 60.7375 16.8926 62.0503 18.2183C63.363 19.544 65.1435 20.2887 67 20.2887"
        stroke="#5AE0A0"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M53 20.2887C54.8565 20.2887 56.637 21.0335 57.9497 22.3592C59.2625 23.6849 60 25.4829 60 27.3577C60 25.4829 60.7375 23.6849 62.0503 22.3592C63.363 21.0335 65.1435 20.2887 67 20.2887"
        stroke="#5AE0A0"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M42.783 7.36351L38.787 6.77678L37 3.12109L35.213 6.77678L31.217 7.36351L34.108 10.2103L33.426 14.2295L37 12.333L40.574 14.2295L39.892 10.2103L42.783 7.36351Z"
        stroke="#5AE0A0"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="square"
      />
      <path
        d="M63.744 46.748L59.748 46.1613L57.961 42.5056L56.173 46.1613L52.177 46.748L55.069 49.5948L54.386 53.6141L57.961 51.7175L61.535 53.6141L60.852 49.5948L63.744 46.748Z"
        stroke="#5AE0A0"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="square"
      />
      <path
        d="M21.783 45.7381L17.787 45.1514L16 41.4957L14.213 45.1514L10.217 45.7381L13.108 48.5849L12.426 52.6042L16 50.7077L19.574 52.6042L18.892 48.5849L21.783 45.7381Z"
        stroke="#5AE0A0"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="square"
      />
      <path
        d="M52 27.3577C50.0757 27.7909 48.2705 28.6496 46.7143 29.872C45.158 31.0943 43.8895 32.6499 43 34.4267"
        stroke="#D1FDE8"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="square"
      />
      <path
        d="M22 27.3577C23.9243 27.7909 25.7295 28.6496 27.2857 29.872C28.842 31.0943 30.1105 32.6499 31 34.4267"
        stroke="#D1FDE8"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="square"
      />
      <path
        d="M22 40.4859C23.6165 39.9803 25.3221 39.8336 27 40.0557C31.363 40.6525 37 44.2223 37 58.6633"
        stroke="#D1FDE8"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="square"
      />
      <path
        d="M52 40.4859C50.3835 39.9803 48.6779 39.8336 47 40.0557C42.637 40.6525 37 44.2223 37 58.6633"
        stroke="#D1FDE8"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="square"
      />
      <path
        d="M37 20.2887V38.4661"
        stroke="#D1FDE8"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="square"
      />
      <path
        d="M8.125 108.841V75.2629C8.125 72.6138 10.2518 70.4661 12.875 70.4661H60.375C62.9982 70.4661 65.125 72.6138 65.125 75.2629V108.841"
        fill="#D1FDE8"
      />
      <path
        d="M8.125 108.841V75.2629C8.125 72.6138 10.2518 70.4661 12.875 70.4661H60.375C62.9982 70.4661 65.125 72.6138 65.125 75.2629V108.841"
        stroke="#5AE0A0"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="square"
      />
      <mask
        id="path-15-outside-1_164_1207"
        maskUnits="userSpaceOnUse"
        x="7.125"
        y="69.4661"
        width="59"
        height="41"
        fill="black"
      >
        <rect fill="white" x="7.125" y="69.4661" width="59" height="41" />
        <path d="M8.125 108.841V75.2629C8.125 72.6138 10.2518 70.4661 12.875 70.4661H60.375C62.9982 70.4661 65.125 72.6138 65.125 75.2629V108.841" />
      </mask>
      <path
        d="M8.125 108.841V75.2629C8.125 72.6138 10.2518 70.4661 12.875 70.4661H60.375C62.9982 70.4661 65.125 72.6138 65.125 75.2629V108.841"
        fill="#D1FDE8"
      />
      <path
        d="M7.125 108.841V109.841H9.125V108.841H7.125ZM64.125 108.841V109.841H66.125V108.841H64.125ZM9.125 108.841V75.2629H7.125V108.841H9.125ZM9.125 75.2629C9.125 73.1569 10.8133 71.4661 12.875 71.4661V69.4661C9.6903 69.4661 7.125 72.0708 7.125 75.2629H9.125ZM12.875 71.4661H60.375V69.4661H12.875V71.4661ZM60.375 71.4661C62.4367 71.4661 64.125 73.1569 64.125 75.2629H66.125C66.125 72.0708 63.5597 69.4661 60.375 69.4661V71.4661ZM64.125 75.2629V108.841H66.125V75.2629H64.125Z"
        fill="black"
        mask="url(#path-15-outside-1_164_1207)"
      />
      <path
        d="M46.125 116.036V119.634H27.125V116.036H1C1 121.334 5.25362 125.63 10.5 125.63H62.75C67.9964 125.63 72.25 121.334 72.25 116.036H46.125Z"
        fill="#5AE0A0"
        stroke="#5AE0A0"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="square"
      />
      <path
        d="M46.125 115.536H45.625V116.036V119.134H27.625V116.036V115.536H27.125H1H0.5V116.036C0.5 121.605 4.97287 126.13 10.5 126.13H62.75C68.2771 126.13 72.75 121.605 72.75 116.036V115.536H72.25H46.125Z"
        fill="#5AE0A0"
        stroke="black"
        stroke-miterlimit="10"
        stroke-linecap="square"
      />
      <path
        d="M53.25 84.8566L37.8125 100.446L28.3125 90.8526L18.8125 100.446"
        stroke="#5AE0A0"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M42.5625 84.8566H53.25V95.6494"
        stroke="#5AE0A0"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="square"
      />
    </svg>
  );
}
export function DemoImage3() {
  return (
    <svg
      width="83"
      height="91"
      viewBox="0 0 83 91"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M65 25.3943H81.6956V74.57H1V25.3943H17.6957" fill="#5AE0A0" />
      <mask
        id="path-2-outside-1_164_1461"
        maskUnits="userSpaceOnUse"
        x="0"
        y="24.3943"
        width="83"
        height="52"
        fill="black"
      >
        <rect fill="white" y="24.3943" width="83" height="52" />
        <path d="M65 25.3943H81.6956V74.57H1V25.3943H17.6957" />
      </mask>
      <path
        d="M65 24.3943H64V26.3943H65V24.3943ZM81.6956 25.3943H82.6956V24.3943H81.6956V25.3943ZM81.6956 74.57V75.57H82.6956V74.57H81.6956ZM1 74.57H0V75.57H1V74.57ZM1 25.3943V24.3943H0V25.3943H1ZM17.6957 26.3943H18.6957V24.3943H17.6957V26.3943ZM65 26.3943H81.6956V24.3943H65V26.3943ZM80.6956 25.3943V74.57H82.6956V25.3943H80.6956ZM81.6956 73.57H1V75.57H81.6956V73.57ZM2 74.57V25.3943H0V74.57H2ZM1 26.3943H17.6957V24.3943H1V26.3943Z"
        fill="black"
        mask="url(#path-2-outside-1_164_1461)"
      />
      <path
        d="M23.2595 90.0251H59.4334"
        stroke="black"
        stroke-miterlimit="10"
        stroke-linecap="square"
      />
      <path
        d="M41.3479 81.5952V90.0253"
        stroke="black"
        stroke-miterlimit="10"
        stroke-linecap="square"
      />
      <path
        d="M26.7441 64.4303H19.5348V22.2043H8L25.3023 1.81934L42.6045 22.2043H31.0697V28.0286"
        fill="#5AE0A0"
      />
      <path
        d="M26.7441 64.4303H19.5348V22.2043H8L25.3023 1.81934L42.6045 22.2043H31.0697V28.0286"
        stroke="#D1FDE8"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="square"
      />
      <path
        d="M41.1627 44.0453C44.3479 44.0453 46.9301 41.4377 46.9301 38.221C46.9301 35.0043 44.3479 32.3967 41.1627 32.3967C37.9774 32.3967 35.3953 35.0043 35.3953 38.221C35.3953 41.4377 37.9774 44.0453 41.1627 44.0453Z"
        stroke="#D1FDE8"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="square"
      />
      <path
        d="M61.3487 64.4305C64.534 64.4305 67.1161 61.8229 67.1161 58.6063C67.1161 55.3896 64.534 52.782 61.3487 52.782C58.1635 52.782 55.5813 55.3896 55.5813 58.6063C55.5813 61.8229 58.1635 64.4305 61.3487 64.4305Z"
        stroke="#D1FDE8"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="square"
      />
      <path
        d="M39.7207 62.9742L62.7904 33.8528"
        stroke="#D1FDE8"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="square"
      />
    </svg>
  );
}
export function DemoImage4() {
  return (
    <svg
      width="116"
      height="63"
      viewBox="0 0 116 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.5 36.0627V36.5627H26H51.4953C51.2315 50.5608 39.913 61.819 26 61.819C11.9218 61.819 0.5 50.2918 0.5 36.0627C0.5 22.0025 11.6523 10.5803 25.5 10.3113V36.0627Z"
        fill="#D1FDE8"
        stroke="black"
        stroke-miterlimit="10"
        stroke-linecap="square"
      />
      <path
        d="M34 1.72754V27.9839H60C60 13.4833 48.359 1.72754 34 1.72754Z"
        fill="#5AE0A0"
        stroke="black"
        stroke-miterlimit="10"
        stroke-linecap="square"
      />
      <line
        x1="61.5"
        y1="14.5"
        x2="76.5"
        y2="14.5"
        stroke="black"
        stroke-linecap="round"
        stroke-dasharray="4 4"
      />
      <path
        d="M91.9971 19.7656V22H81.4053V20.0879L86.4863 14.5986C87.0163 13.9971 87.4352 13.4743 87.7432 13.0303C88.0511 12.5863 88.2695 12.1852 88.3984 11.8271C88.5345 11.4619 88.6025 11.1146 88.6025 10.7852C88.6025 10.3053 88.5166 9.88639 88.3447 9.52832C88.1729 9.16309 87.9222 8.88021 87.5928 8.67969C87.2705 8.47917 86.873 8.37891 86.4004 8.37891C85.8776 8.37891 85.43 8.50065 85.0576 8.74414C84.6924 8.98047 84.4131 9.3099 84.2197 9.73242C84.0335 10.1549 83.9404 10.6383 83.9404 11.1826H81.0938C81.0938 10.2588 81.3086 9.41732 81.7383 8.6582C82.168 7.89193 82.7839 7.27962 83.5859 6.82129C84.388 6.36296 85.3405 6.13379 86.4434 6.13379C87.5176 6.13379 88.4271 6.31283 89.1719 6.6709C89.9167 7.02181 90.4824 7.52311 90.8691 8.1748C91.2559 8.8265 91.4492 9.60352 91.4492 10.5059C91.4492 11.0072 91.3669 11.5013 91.2021 11.9883C91.0374 12.4753 90.8047 12.9587 90.5039 13.4385C90.2103 13.9111 89.8594 14.391 89.4512 14.8779C89.043 15.3649 88.5882 15.8626 88.0869 16.3711L85.0361 19.7656H91.9971ZM96.7881 14.8027L94.5215 14.2549L95.3916 6.35938H103.996V8.71191H97.7441L97.3359 12.3643C97.5579 12.2282 97.8802 12.0921 98.3027 11.9561C98.7324 11.8128 99.2158 11.7412 99.7529 11.7412C100.498 11.7412 101.164 11.863 101.751 12.1064C102.338 12.3428 102.836 12.6865 103.244 13.1377C103.66 13.5889 103.971 14.1403 104.179 14.792C104.394 15.4365 104.501 16.167 104.501 16.9834C104.501 17.6995 104.394 18.3727 104.179 19.0029C103.971 19.626 103.652 20.181 103.223 20.668C102.793 21.1478 102.252 21.5273 101.601 21.8066C100.949 22.0788 100.183 22.2148 99.3018 22.2148C98.6357 22.2148 97.9948 22.1182 97.3789 21.9248C96.7702 21.7243 96.2223 21.4342 95.7354 21.0547C95.2484 20.668 94.8581 20.1953 94.5645 19.6367C94.278 19.0781 94.1204 18.4372 94.0918 17.7139H96.8955C96.9456 18.1937 97.0745 18.6019 97.2822 18.9385C97.4899 19.2751 97.762 19.5329 98.0986 19.7119C98.4424 19.891 98.8398 19.9805 99.291 19.9805C99.6992 19.9805 100.05 19.9053 100.344 19.7549C100.645 19.5973 100.892 19.3789 101.085 19.0996C101.278 18.8203 101.422 18.4909 101.515 18.1113C101.608 17.7318 101.654 17.3164 101.654 16.8652C101.654 16.4284 101.601 16.0309 101.493 15.6729C101.386 15.3076 101.221 14.9925 100.999 14.7275C100.777 14.4626 100.498 14.2585 100.161 14.1152C99.8317 13.972 99.445 13.9004 99.001 13.9004C98.4066 13.9004 97.9482 13.9899 97.626 14.1689C97.3109 14.348 97.0316 14.5592 96.7881 14.8027ZM106.098 14.4873V13.9609C106.098 13.5827 106.18 13.2386 106.344 12.9287C106.508 12.6188 106.747 12.3704 107.062 12.1836C107.376 11.9967 107.754 11.9033 108.196 11.9033C108.652 11.9033 109.035 11.9967 109.345 12.1836C109.659 12.3704 109.898 12.6188 110.062 12.9287C110.227 13.2386 110.309 13.5827 110.309 13.9609V14.4873C110.309 14.8564 110.227 15.196 110.062 15.5059C109.903 15.8158 109.666 16.0641 109.352 16.251C109.042 16.4378 108.661 16.5312 108.21 16.5312C107.763 16.5312 107.381 16.4378 107.062 16.251C106.747 16.0641 106.508 15.8158 106.344 15.5059C106.18 15.196 106.098 14.8564 106.098 14.4873ZM107.239 13.9609V14.4873C107.239 14.6696 107.273 14.8428 107.342 15.0068C107.415 15.1709 107.524 15.3031 107.67 15.4033C107.816 15.5036 107.996 15.5537 108.21 15.5537C108.429 15.5537 108.606 15.5036 108.743 15.4033C108.884 15.3031 108.989 15.1709 109.058 15.0068C109.126 14.8428 109.16 14.6696 109.16 14.4873V13.9609C109.16 13.7741 109.124 13.5986 109.051 13.4346C108.982 13.266 108.878 13.1315 108.736 13.0312C108.595 12.931 108.415 12.8809 108.196 12.8809C107.987 12.8809 107.809 12.931 107.663 13.0312C107.522 13.1315 107.415 13.266 107.342 13.4346C107.273 13.5986 107.239 13.7741 107.239 13.9609ZM110.896 20.0928V19.5596C110.896 19.1859 110.979 18.8441 111.143 18.5342C111.311 18.2243 111.553 17.9759 111.867 17.7891C112.182 17.6022 112.56 17.5088 113.002 17.5088C113.458 17.5088 113.84 17.6022 114.15 17.7891C114.465 17.9759 114.702 18.2243 114.861 18.5342C115.025 18.8441 115.107 19.1859 115.107 19.5596V20.0928C115.107 20.4665 115.025 20.8083 114.861 21.1182C114.702 21.4281 114.467 21.6764 114.157 21.8633C113.847 22.0501 113.469 22.1436 113.022 22.1436C112.571 22.1436 112.186 22.0501 111.867 21.8633C111.553 21.6764 111.311 21.4281 111.143 21.1182C110.979 20.8083 110.896 20.4665 110.896 20.0928ZM112.045 19.5596V20.0928C112.045 20.2751 112.081 20.4482 112.154 20.6123C112.232 20.7764 112.343 20.9108 112.489 21.0156C112.635 21.1159 112.811 21.166 113.016 21.166C113.248 21.166 113.435 21.1159 113.576 21.0156C113.717 20.9108 113.818 20.7786 113.877 20.6191C113.941 20.4551 113.973 20.2796 113.973 20.0928V19.5596C113.973 19.3727 113.936 19.1973 113.863 19.0332C113.795 18.8691 113.688 18.737 113.542 18.6367C113.401 18.5365 113.221 18.4863 113.002 18.4863C112.788 18.4863 112.61 18.5365 112.469 18.6367C112.327 18.737 112.22 18.8691 112.147 19.0332C112.079 19.1973 112.045 19.3727 112.045 19.5596ZM113.412 13.4688L108.552 21.248L107.711 20.7627L112.571 12.9834L113.412 13.4688Z"
        fill="#5AE0A0"
      />
    </svg>
  );
}
